import { useTranslation } from 'react-i18next'

import Button from '../../../../Button'
import { PageEmptyState } from '../../../../PageEmptyState'
import Text from '../../../../Text'

import RefreshIcon from '../../../../../icons/refresh.svg'
import RentalPortalIcon from '../../../../../icons/rental-portal.svg'

function RentalPortalListingProfileTabLoadError({
  isLoading,
  qaName,
  textKey,
  onRetry,
}) {
  const { t } = useTranslation()

  return (
    <PageEmptyState EntityIcon={RentalPortalIcon}>
      <Text isSecondary>{t(textKey)}</Text>
      <Button.Flat
        beforeIconProps={{ Icon: RefreshIcon }}
        isLoading={isLoading}
        qaName={qaName}
        text={t('RentalPortal.ListingRetryBtnKey')}
        onClick={onRetry}
      />
    </PageEmptyState>
  )
}

export default RentalPortalListingProfileTabLoadError
